// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}

ion-card {
  height: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
}

ion-card-content {
  flex: 1;
  min-height: 0;
}

.totale-centro {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  text-align: center;
}
.totale-centro .totale-ore {
  font-size: 1.4rem;
  font-weight: 700;
  color: var(--ion-text-color);
}
.totale-centro .totale-risorse {
  font-size: 0.75rem;
  color: var(--ion-color-medium);
}

.legenda-link {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
  list-style: none;
  margin: 0;
  padding: 0 16px 12px;
}
.legenda-link button,
.legenda-link .voce {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: 0;
  padding: 2px;
  font-size: 0.75rem;
  color: var(--ion-text-color);
}
.legenda-link button {
  cursor: pointer;
}
.legenda-link button:hover, .legenda-link button:focus-visible {
  color: var(--ion-color-primary);
  text-decoration: underline;
}
.legenda-link .pallino {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--ion-color-medium);
}
.legenda-link .ore {
  color: var(--ion-color-medium);
}`, "",{"version":3,"sources":["webpack://./src/app/_components/charts/pie-chart/pie-chart.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,OAAA;EACA,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;AACF;AACE;EACE,iBAAA;EACA,gBAAA;EACA,4BAAA;AACJ;AAEE;EACE,kBAAA;EACA,8BAAA;AAAJ;;AAIA;EACE,aAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,SAAA;EACA,oBAAA;AADF;AAGE;;EAEE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,4BAAA;AADJ;AAIE;EACE,eAAA;AAFJ;AAII;EAEE,+BAAA;EACA,0BAAA;AAHN;AAOE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mCAAA;AALJ;AAQE;EACE,8BAAA;AANJ","sourcesContent":[":host {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\nion-card {\n  height: 100%;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n}\n\nion-card-content {\n  flex: 1;\n  min-height: 0;\n}\n\n.totale-centro {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n  text-align: center;\n\n  .totale-ore {\n    font-size: 1.4rem;\n    font-weight: 700;\n    color: var(--ion-text-color);\n  }\n\n  .totale-risorse {\n    font-size: 0.75rem;\n    color: var(--ion-color-medium);\n  }\n}\n\n.legenda-link {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px 12px;\n  list-style: none;\n  margin: 0;\n  padding: 0 16px 12px;\n\n  button,\n  .voce {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    background: none;\n    border: 0;\n    padding: 2px;\n    font-size: 0.75rem;\n    color: var(--ion-text-color);\n  }\n\n  button {\n    cursor: pointer;\n\n    &:hover,\n    &:focus-visible {\n      color: var(--ion-color-primary);\n      text-decoration: underline;\n    }\n  }\n\n  .pallino {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background: var(--ion-color-medium);\n  }\n\n  .ore {\n    color: var(--ion-color-medium);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
